import React, { useMemo } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import Selector from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import GraficoPizza from './GraficoPizza';
import { CODIGO_PERGUNTA_ORIGEM, CODIGO_PERGUNTA_MIDIA, CODIGO_PERGUNTA_CAMPANHA } from './constants';

export default function PainelGraficosPizza({
  dados,
  totalCaptados,
  filtrosOrigem,
  onFiltrosOrigemChange,
}) {
  var dadosOrigem = useMemo(function() {
    return (dados || []).filter(function(d) { return d.codigo === CODIGO_PERGUNTA_ORIGEM; });
  }, [dados]);

  var dadosMidia = useMemo(function() {
    return (dados || []).filter(function(d) { return d.codigo === CODIGO_PERGUNTA_MIDIA; });
  }, [dados]);

  var dadosCampanha = useMemo(function() {
    return (dados || []).filter(function(d) { return d.codigo === CODIGO_PERGUNTA_CAMPANHA; });
  }, [dados]);

  var optionsOrigem = useMemo(function() {
    var opts = [{ value: '', label: 'Todos' }];
    dadosOrigem.forEach(function(d) { opts.push({ value: d.dissertativa, label: d.dissertativa }); });
    return opts;
  }, [dadosOrigem]);

  var optionsMidia = useMemo(function() {
    var opts = [{ value: '', label: 'Todos' }];
    dadosMidia.forEach(function(d) { opts.push({ value: d.dissertativa, label: d.dissertativa }); });
    return opts;
  }, [dadosMidia]);

  var optionsCampanha = useMemo(function() {
    var opts = [{ value: '', label: 'Todos' }];
    dadosCampanha.forEach(function(d) { opts.push({ value: d.dissertativa, label: d.dissertativa }); });
    return opts;
  }, [dadosCampanha]);

  var handleChange = function(campo, valor) {
    var novo = Object.assign({}, filtrosOrigem);
    novo[campo] = valor;
    onFiltrosOrigemChange(novo);
  };

  return (
    <Card className="mb-3 shadow-sm" style={{ borderTop: '3px solid #0747a6' }}>
      <Card.Header className="py-2">
        <h6 className="mb-0" style={{ color: '#0747a6', fontSize: '0.9rem' }}>
          Total de Prospectos Captados: <strong>{totalCaptados != null ? totalCaptados : 0}</strong>.
          {' '}Voce pode filtrar os resultados do relatorio por Origem, Midia e Campanha.
        </h6>
      </Card.Header>
      <Card.Body className="py-3">
        <Row>
          <Col xs={12} md={4}>
            <GraficoPizza titulo="Origem" dados={dadosOrigem} />
            <Selector
              styles={customStyles}
              components={{ DropdownIndicator: DropdownIndicator }}
              className="mt-2"
              options={optionsOrigem}
              value={optionsOrigem.find(function(o) { return o.value === filtrosOrigem.origem; }) || optionsOrigem[0]}
              onChange={function(option) { handleChange('origem', option ? option.value : ''); }}
              noOptionsMessage={function() { return 'Nenhuma opcao encontrada'; }}
            />
          </Col>
          <Col xs={12} md={4}>
            <GraficoPizza titulo="Midia" dados={dadosMidia} />
            <Selector
              styles={customStyles}
              components={{ DropdownIndicator: DropdownIndicator }}
              className="mt-2"
              options={optionsMidia}
              value={optionsMidia.find(function(o) { return o.value === filtrosOrigem.midia; }) || optionsMidia[0]}
              onChange={function(option) { handleChange('midia', option ? option.value : ''); }}
              noOptionsMessage={function() { return 'Nenhuma opcao encontrada'; }}
            />
          </Col>
          <Col xs={12} md={4}>
            <GraficoPizza titulo="Campanha" dados={dadosCampanha} />
            <Selector
              styles={customStyles}
              components={{ DropdownIndicator: DropdownIndicator }}
              className="mt-2"
              options={optionsCampanha}
              value={optionsCampanha.find(function(o) { return o.value === filtrosOrigem.campanha; }) || optionsCampanha[0]}
              onChange={function(option) { handleChange('campanha', option ? option.value : ''); }}
              noOptionsMessage={function() { return 'Nenhuma opcao encontrada'; }}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
